import {
  IApiServiceStateViewModel,
  IAPIServiceStateFacade,
} from '../mobxUtils.types'

export class APIServiceStateFacade<
  Params extends unknown[],
  Response,
  ERROR = unknown,
> implements IAPIServiceStateFacade<Params, Response>
{
  public stateViewModel: IApiServiceStateViewModel<Response, ERROR>
  private requestMethod: (...params: Params) => Promise<Response>
  private latestRequestId = 0

  constructor(state: IApiServiceStateViewModel<Response, ERROR>) {
    this.stateViewModel = state
  }

  public injectRequestMethod = (
    requestMethod: (...params: Params) => Promise<Response>
  ) => {
    this.requestMethod = requestMethod
  }

  public cancelPendingRequests = () => {
    this.latestRequestId++
  }

  public request = async (...params: Params) => {
    const requestId = ++this.latestRequestId
    this.stateViewModel.setStatus('LOADING')
    try {
      const result = await this.requestMethod(...params)
      if (requestId !== this.latestRequestId) {
        return result
      }

      this.stateViewModel.setState(result)
      this.stateViewModel.setStatus('SUCCESS')
      return result
    } catch (e: unknown) {
      if (requestId === this.latestRequestId) {
        this.stateViewModel.setStatus('ERROR')
        this.stateViewModel.setError(e as any)
      }
      throw e
    }
  }
}
